import axios from 'axios';
import config from 'api/urls-config.json';

export const getContactsPage = params => {
    return axios.get(`${config.API + config.pages.contacts}`, { params });
};
